module.exports = __webpack_public_path__ + "img/auth-apple.2584ad7.svg";